import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IResetLoginRateLimitingOnSiteUsersParams {
  siteUserIds?: string[];
}

export interface IResetLoginRateLimitingOnSiteUsersResult extends IResult {
}

export class ResetLoginRateLimitingOnSiteUsersRequest extends Request<IResetLoginRateLimitingOnSiteUsersParams, IResetLoginRateLimitingOnSiteUsersResult> {
  constructor(params: IResetLoginRateLimitingOnSiteUsersParams) {
    super('resetLoginRateLimitingOnSiteUsers', params);
  }
}
